export default "__VITE_ASSET__DICVc8FP__"